'use client';

import { useRouter } from 'next/navigation';
import { PrismicNextLink } from '@prismicio/next';
import { asText, RichTextField } from '@prismicio/client';

import { Box, Icon, Typography } from '@preventx/oxygen';

// Services
import { retrieveIcon } from '@/services/styling/icons';

type BackProps = {
  backLabel: RichTextField;
};

/** **Important**: This component is specifically designed to navigate back in the page history
 * so do not alter the default configuration as you may break pages using this component.*/
export const Back = ({ backLabel }: BackProps) => {
  const router = useRouter();

  return (
    <Box component="div">
      <PrismicNextLink
        href="#"
        onClick={() => router.back()}
        className="link link--subtle cluster gap-sm"
      >
        <Icon icon={retrieveIcon('Arrow Left')} className="icon-directional" />
        <Typography component="span">{asText(backLabel)}</Typography>
      </PrismicNextLink>
    </Box>
  );
};
